import React, {useState } from 'react';
import { Card, Row, Col, Statistic, Divider, Button, List } from 'antd';
import { TeamOutlined, CalendarOutlined, TrophyOutlined, MergeCellsOutlined, LinkOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { motion } from 'motion/react';
import AddTournamentParticipant from '../../components/AddTournamentParticipant';
import UpdateDecklists from '../../components/UpdateDecklists';
import { dateFormat } from '../../utils';
import RankingTable from '../../components/RankingTable';
import ParticipantTable from '../../components/ParticipantTable';
import * as Setting from '../../utils/AuthUtils';
import UpdateTournament from '../../components/UpdateTournament';
import AssignBye from '../../components/AssignBye';
import { filterByes } from '../../utils/DataUtils';

function Tournament(props) {
  const [editable, setEditable] = useState(false)

  async function addPlayer(stageId, participant) {
    // console.warn('arrivato alla chiamata ajax! ', participant)
    participant.tournamentId = stageId;
    // setLoading(true)
    props.addPlayer.mutate(participant);
  }

  function toggleEditable(e) {
    e.preventDefault();
    if (editable) {
      setEditable(false)
    } else {
      setEditable(true)
    }
  }

  function setSplitLabel(tournament) {
    if (tournament && tournament.multiplier) {
      switch (tournament.multiplier.id) {
        case 6:
          return "Top8";
        case 7:
          return "Top4";
        case 8:
          return "Top2";
        default:
          return "None";
      }
    }
    return '';
  }

  function showByes(byes) {
    const showRes = [];
    byes.forEach(bye => {
      showRes.push(<Col span={4}><Card>{bye.playerInfo.lastName} {bye.playerInfo.firstName}</Card></Col>)
    });
    return showRes;
  }

  const participants = (props.participants.data && props.participants.data.payLoad !== null ? props.participants.data.payLoad : []);
  const tournament = (props.tournament.data && props.tournament.data.payLoad !== null ? props.tournament.data.payLoad : {});
  const dividerTitle = (props.tournament.data && props.tournament.data.payLoad !== null && props.tournament.data.payLoad.turns > 10 ? 'Top16' : 'Top8');
  const byes = (props.byes.data && props.byes.data.payLoad !== null ? filterByes(props.byes.data.payLoad, props.id) : [])
  console.warn('byes del torneo assegnati:', byes)
  if (tournament.isDone === true || editable) {
    return (
      <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} style={{ padding: '0 50px'}}>
      <Card loading={ props.tournament.pending || props.participants.pending } title={tournament.name} style={{ marginTop: '24px' }}>
        <Row gutter={16} justify="center">
          <Col span={4}>
            <Statistic title="Date" value={dateFormat(tournament.date)} prefix={<CalendarOutlined />} />
          </Col>
          <Col span={4}>
            <Statistic title="Event Type" value={(tournament && tournament.type && tournament.type.desc) || ''} prefix={<TrophyOutlined />}/> 
          </Col>
          { tournament && tournament.type && tournament.type.id > 3 && tournament.type.id !== 14 &&
            <Col span={4}>
              <Statistic title="Swiss Rounds" value={tournament.turns} prefix={<MergeCellsOutlined />} />
            </Col>
          }
          <Col span={4}>
            <Statistic title="Participants" value={tournament.playerAttendancy} prefix={<TeamOutlined />}/>
          </Col>
          <Col span={4}>
            <Statistic title="Split" value={setSplitLabel(tournament)} prefix={<TeamOutlined />}/>
          </Col>
        </Row >
          { Setting.isLoggedIn() && (props.hasRights.isAdmin || props.hasRights.isReferral ) && 
            <Row justify="center">
              <Col span={6}><AddTournamentParticipant onAddPlayer={addPlayer} stageId={tournament.id}/></Col>
              <Col span={6}><UpdateTournament tournament={tournament} multipliers={props.multipliers} rights={props.hasRights}/></Col>
            </Row>
          }
        <Divider>Event Infos</Divider>
        <Row gutter={16} justify="center">
          <Col span={8}>
            <Statistic title="Tournament Organizer" value={`Lega Pauper ${tournament.leagueInfos.leagueName}`} prefix={<TeamOutlined />} />
          </Col>
          <Col span={8}>
            <Statistic title="Location" value={tournament.place} prefix={<EnvironmentOutlined />} />
          </Col>
          <Col span={8}>
            <Statistic title="Link" value={tournament.externalLink} prefix={<LinkOutlined />} />
          </Col>
        </Row>
        {
          tournament && tournament.hasByes &&
          <>
          <Divider>Byes</Divider>
            <p><b>{byes.length || ''}</b> byes assigned for this tournament</p>
            <Row justify="space-evenly">
              {showByes(byes)}
            </Row>
            <Row justify="center">
              <Col span={6}><AssignBye tournament={tournament} participant={participants} lpiSeasons={props.lpiSeasons}/></Col>
            </Row>
          </>
        }
        <Divider>Decklists</Divider>
        <Row gutter={16} justify="center">
          <Col span={12} style={{fontSize:"20px"}}>
            <a href={tournament.decklist || '#'} target="_blank" rel="noreferrer"><p><LinkOutlined /> {tournament.decklist || ' Not available'}</p></a>
          </Col>
        </Row>
          {
              Setting.isLoggedIn() && (props.hasRights.isAdmin || props.hasRights.isReferral ) && tournament.isDone === true && 
              <Row gutter={16} justify="center">
                <Col span={12} style={{fontSize:"20px"}}>
                  <UpdateDecklists tournament={tournament} />
                </Col>
              </Row>
          }
        <Divider>{dividerTitle}</Divider>
        <Row>
          <Col span={24}>
            {
              Setting.isLoggedIn() && (props.hasRights.isAdmin || props.hasRights.isReferral ) && tournament.isDone === true && editable === false &&
              <Row justify="center">
                <Col span={4}><Button style={{ marginBottom: 16 }} onClick={toggleEditable} type="primary">EDIT RANKING</Button></Col>
              </Row>
            }
            <RankingTable admin={props.hasRights.isAdmin} editing={editable} toggleEditing={toggleEditable} isTournament={true} dataSource={participants} {...props} />
          </Col>
        </Row>
      </Card>
      </motion.div>
    );
  }
  return (
      <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} style={{ padding: '0 50px'}}>
      <Card loading={props.tournament.pending || props.participants.pending} title={tournament.name} style={{ marginTop: '24px' }}>
        <Row gutter={16} justify="center">
          <Col span={4}>
            <Statistic title="Date" value={dateFormat(tournament.date)} prefix={<CalendarOutlined />} />
          </Col>
          { tournament && tournament.type && tournament.type.id > 3 &&
            <Col span={4}>
              <Statistic title="Swiss Rounds" value={tournament.turns} prefix={<MergeCellsOutlined />} />
            </Col>
          }
          <Col span={4}>
            <Statistic title="Participants" value={tournament.playerAttendancy} prefix={<TeamOutlined />}/>
          </Col>
          <Col span={4}>
            <Statistic title="Split" value={setSplitLabel(tournament)} prefix={<TeamOutlined />}/>
          </Col>
        </Row >
        { Setting.isLoggedIn() && (props.hasRights.isAdmin || props.hasRights.isReferral ) && !tournament.isDone && 
          <Row justify="center">
            <Col span={8}><AddTournamentParticipant onAddPlayer={addPlayer} stageId={tournament.id}/></Col>
            <Col span={8}><UpdateTournament tournament={tournament} multipliers={props.multipliers} rights={props.hasRights}/></Col>
          </Row>
        }
        <Divider>Event Infos</Divider>
        <Row gutter={16} justify="center">
          <Col span={8}>
            <Statistic title="Tournament Organizer" value={`Lega Pauper ${(tournament && tournament.leagueInfos ? tournament.leagueInfos.leagueName: "")}`} prefix={<TeamOutlined />} />
          </Col>
          <Col span={8}>
            <Statistic title="Location" value={tournament.place} prefix={<EnvironmentOutlined />} />
          </Col>
          <Col span={8}>
            <Statistic title="Link" value={tournament.externalLink} prefix={<LinkOutlined />} />
          </Col>
        </Row>
        <Divider>Decklists</Divider>
        <Row gutter={16} justify="center">
          <Col span={12}>
            <Statistic title="Link" value={tournament.decklist} prefix={<LinkOutlined />} />
          </Col>
        </Row >
        <Divider>Ranking</Divider>
        {
          Setting.isLoggedIn() && (props.hasRights.isAdmin || props.hasRights.isReferral ) && tournament.isDone !== true && tournament.playerAttendancy > 0 && editable === false &&
          <Row justify="center">
            <Col span={4}><Button style={{ marginBottom: 16 }} onClick={toggleEditable} type="primary">UPDATE RANKING</Button></Col>
          </Row>
        }
        {
          Setting.isLoggedIn() && (props.hasRights.isAdmin || props.hasRights.isReferral ) && tournament.isDone === true && editable === false &&
          <Row justify="center">
            <Col span={4}><Button style={{ marginBottom: 16 }} onClick={toggleEditable} type="primary">EDIT RANKING</Button></Col>
          </Row>
        }
        <Row>
          <Col span={24} style={{padding: '10px'}}>
            <ParticipantTable admin={props.hasRights.isAdmin} rights={props.hasRights} editing={editable} toggleEditing={toggleEditable} dataSource={participants} {...props} />
          </Col>
        </Row>
      </Card>
      </motion.div>
  );
}

export default Tournament;